import initialState from './state';
import BuyerOverridesActionTypes from './actionTypes';
const buyerOverridesReducer = (state = initialState, action) => {
  var _action$data$quantiti, _action$data$prices, _action$data$selectio;
  switch (action.type) {
    case BuyerOverridesActionTypes.SET_LOADING:
      return Object.assign({}, state, {
        isLoading: action.data.isLoading
      });
    case BuyerOverridesActionTypes.SET_QUANTITY:
      return Object.assign({}, state, {
        quantities: Object.assign({}, state.quantities, {
          [action.data.id]: action.data.quantity
        })
      });
    case BuyerOverridesActionTypes.SET_PRICE:
      return Object.assign({}, state, {
        prices: Object.assign({}, state.prices, {
          [action.data.id]: action.data.price
        })
      });
    case BuyerOverridesActionTypes.SET_EXPIRED_FUTURE_START_DATE_LINE_ITEMS:
      return Object.assign({}, state, {
        expiredFutureStartDateLineItemIds: action.data.expiredFutureStartDateLineItemIds
      });
    case BuyerOverridesActionTypes.SET_PARTIAL_PAYMENT_AMOUNT:
      return Object.assign({}, state, {
        partialPaymentAmount: action.data.partialPaymentAmount
      });
    case BuyerOverridesActionTypes.SELECTION_TOGGLED:
      {
        const nextState = Object.assign({}, state, {
          selections: Object.assign({}, state.selections, {
            [action.data.id]: !state.selections[action.data.id]
          })
        });
        if ('quantity' in action.data) {
          nextState.quantities = Object.assign({}, state.quantities, {
            [action.data.id]: action.data.quantity
          });
        }
        if ('price' in action.data) {
          nextState.prices = Object.assign({}, state.prices, {
            [action.data.id]: action.data.price
          });
        }
        return nextState;
      }
    case BuyerOverridesActionTypes.RESTORE_STATE:
      return Object.assign({}, state, {
        quantities: (_action$data$quantiti = action.data.quantities) !== null && _action$data$quantiti !== void 0 ? _action$data$quantiti : state.quantities,
        prices: (_action$data$prices = action.data.prices) !== null && _action$data$prices !== void 0 ? _action$data$prices : state.prices,
        selections: (_action$data$selectio = action.data.selections) !== null && _action$data$selectio !== void 0 ? _action$data$selectio : state.selections
      });
    default:
      return state;
  }
};
export default buyerOverridesReducer;